module.exports = __webpack_public_path__ + "static/media/appwiz_1501.d7f3d736.ico";